/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TracingService {
    /**
     * Generate a test trace
     * @returns any Test trace generated successfully
     * @throws ApiError
     */
    public static tracingControllerGenerateTestTraceV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tracing/test',
        });
    }
    /**
     * Generate a custom trace with data
     * @returns any Custom trace generated successfully
     * @throws ApiError
     */
    public static tracingControllerGenerateCustomTraceV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/tracing/custom',
        });
    }
    /**
     * Get OpenTelemetry status
     * @returns any OpenTelemetry status retrieved successfully
     * @throws ApiError
     */
    public static tracingControllerGetTracingStatusV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tracing/status',
        });
    }
}
